module.exports = __webpack_public_path__ + "static/media/lender.eeea1590.jpg";